var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8PasDeWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.484375 3.984375 A 1.50015 1.50015 0 0 0 4.4394531 6.5605469 L 6.1015625 8.2226562 C 5.414835 9.1386835 5 10.269159 5 11.5 L 5 36.5 C 5 39.532 7.467 42 10.5 42 L 37.5 42 C 38.204528 42 38.871729 41.855024 39.490234 41.611328 L 41.439453 43.560547 A 1.50015 1.50015 0 1 0 43.560547 41.439453 L 6.5605469 4.4394531 A 1.50015 1.50015 0 0 0 5.484375 3.984375 z M 12.363281 6 L 21.363281 15 L 40 15 L 40 33.636719 L 42.990234 36.628906 C 42.991234 36.585906 43 36.543 43 36.5 L 43 11.5 C 43 8.468 40.532 6 37.5 6 L 12.363281 6 z M 20.5 9 C 21.328 9 22 9.672 22 10.5 C 22 11.328 21.328 12 20.5 12 C 19.672 12 19 11.328 19 10.5 C 19 9.672 19.672 9 20.5 9 z M 25.5 9 L 37.5 9 C 38.328 9 39 9.672 39 10.5 C 39 11.328 38.328 12 37.5 12 L 25.5 12 C 24.672 12 24 11.328 24 10.5 C 24 9.672 24.672 9 25.5 9 z M 8 15 L 12.878906 15 L 36.878906 39 L 10.5 39 C 9.122 39 8 37.879 8 36.5 L 8 15 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PasDeWeb);
export default __webpack_public_path__ + "static/media/icons8-pas-de-web.d0e935ef06edebd2352771130abe6cb9.svg";
export { ForwardRef as ReactComponent };